import React from 'react';
import Button from '../common/Button';
import { useTranslation } from 'react-i18next';
import { formatDateTime } from '../../utils/datetime';

interface LegalPersonReferenceDetailModalProps {
    isOpen: boolean;
    onClose: () => void;
    referenceDetailData?: any;
    fieldName?: string;
}

const LegalPersonReferenceDetailModal: React.FC<LegalPersonReferenceDetailModalProps> = ({ 
    isOpen, 
    onClose, 
    referenceDetailData, 
    fieldName 
}) => {
    const { t } = useTranslation('verification');
    if (!isOpen || !referenceDetailData) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-40 items-center z-50">
            <div className="bg-white my-[15%] mx-auto w-4/5 max-w-lg p-5 border-[#888] rounded text-left text-black">
                <span
                    className="close"
                    onClick={onClose}
                >
                    ×
                </span>
                <h2>{t('detail info')}</h2>
                <div>
                    <p>
                        <strong>{t('corporate name')} : </strong>
                        <span>{referenceDetailData.corporateName}</span>
                    </p>
                    <p>
                        <strong>{t('corporate number')} : </strong>
                        <span>{referenceDetailData.corporateNumber}</span>
                    </p>
                    <p>
                        <strong>{t('reference person')} : </strong>
                        <span>{referenceDetailData.applicantName}</span>
                    </p>
                    <p>
                        <strong>{t('reference datetime')} : </strong>
                        <span>{formatDateTime(referenceDetailData.legalPersonReference_receivedDate)}</span>
                    </p>
                    <p>
                        <strong>{t('verified datetime')} : </strong>
                        <span>{formatDateTime(referenceDetailData.legalPersonReference_verificationDate)}</span>
                    </p>
                    <p>
                        <strong>{t('legal person verification status')} : </strong>
                        <span>
                            {referenceDetailData.legalPersonReference_status === "verified" 
                                ? t(referenceDetailData.legalPersonReference_result) 
                                : t(referenceDetailData.legalPersonReference_status)}
                        </span>
                    </p>
                    <p>
                        <strong>{t('aml risk check status')} : </strong>
                        <span>
                            {referenceDetailData.amlRiskCheck_status === "completed" 
                                ? t(referenceDetailData.amlRiskCheck_result) 
                                : t(referenceDetailData.amlRiskCheck_status)}
                        </span>
                    </p>
                </div>
                <div className='flex flex-row justify-start'>
                    <div className='m-[10px]'>
                        <Button
                            label={t('close')}
                            onClick={onClose}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LegalPersonReferenceDetailModal;
